import React, {Component} from 'react';
import {Link} from 'components/ReactRouterDomLocalized';

import VirtualGiftList from 'components/virtualgift/VirtualGiftList';

import {t} from 'l10n'

import paths from 'paths';

import 'sass/profile/giftsProfile.scss';

class ProfileVirtualGiftsBlock extends Component {
    constructor(props) {
        super(props);

        this.state = {}
    }

    render() {
        let {virtualGifts, sectionNumber, user} = this.props,
            {list} = virtualGifts;

        return (
            <aside className={'gifts-main ' + ((sectionNumber % 2)==0?'even':'odd')}>
                <div className="content">
                    <div className="heading">
                        <h2>{t('Virtual gifts')}{user.gift_points > 0 && <em>{t('%1 points', user.gift_points)}</em>}</h2>
                    <Link to={{pathname: paths.virtualGifts.path, search: '?r=' + encodeURIComponent(user.nick)}}
                        className="add-item"
                    >{t('Give a virtual gift')}</Link>
                    </div>

                    <VirtualGiftList
                        virtualGifts={list}
                        singleRow
                    />

                    <div className="view-all-placehoder"></div>
                </div>
            </aside>
        )
    }
}

export default ProfileVirtualGiftsBlock;


// WEBPACK FOOTER //
// ./src/components/profile/ProfileVirtualGiftsBlock.js